import React from "react";
import { useSelector } from "react-redux";
import "./BasicReports.scss";
import Scorecard from "./Scorecard/Scorecard";
import SubjectWise from "./SubjectWise/SubjectWise";
import GoToAdvAnalytics from "./GoToAdvAnalytics/GoToAdvAnalytics";
import GoToAdvAnalytics1 from "./GoToAdvAnalytics1/GoToAdvAnalytics1";
import Buttons from "./Buttons/Buttons";
import PerformanceInsights from "../sharedAnalytics/performanceInsights";

const AITS_YEARWISE_SOURCES = new Set(["paperlisting", "yearwise"]);

const BasicReports = ({ basicAnalytics }) => {
  const testDetails = useSelector((state) => state.examSlice.testDetails);
  const showPerformanceInsights =
    testDetails?.practiceMode !== "practice" &&
    AITS_YEARWISE_SOURCES.has(String(testDetails?.source || ""));

  return (
    <div className="basic-reports">
      <Scorecard basicAnalytics={basicAnalytics} />
      <GoToAdvAnalytics />

      <SubjectWise subjectWiseAnalysis={basicAnalytics?.subject_wise_analysis} />

      {showPerformanceInsights ? (
        <PerformanceInsights analytics={basicAnalytics} />
      ) : null}

      <GoToAdvAnalytics1 />
      <Buttons />
    </div>
  );
};

export default BasicReports;
